
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Mumbaitogoacabs() {



    const cardData =
    {
        keyword: 'Mumbai to Goa Cab',
        heading: 'Meghana Cab : Mumbai to Goa Cab ',
        headingDescription: 'Meghana Cab offers Mumbai to Goa Cab services, providing a smooth, luxurious, and enjoyable travel experience along India’s most scenic coastal route. Covering approximately 590 kilometers, our well-maintained air-conditioned sedans, SUVs, and tempo travellers ensure complete comfort throughout your journey. Whether you’re heading for a beach holiday, business trip, or family vacation, our experienced drivers guarantee safe, timely, and hassle-free travel. Enjoy door-to-door pickup, flexible booking options, and transparent pricing with no hidden charges. With 24×7 customer support and a commitment to reliability, Meghana Cab makes your Mumbai to Goa trip a delightful and memorable ride.',


        top: 'Top Places to Visit in Goa with Meghana Cab',

"topPlaces": [
  {
    "title": "Calangute and Baga Beaches",
    "description": "Calangute and Baga are two of Goa’s most iconic and vibrant beaches, known for their golden sands, energetic nightlife, and endless water adventures. Calangute, often called the 'Queen of Beaches', offers parasailing, jet-skiing, and banana boat rides along its vast coastline. Baga, just a short walk away, is famous for its beach shacks, live music, and nightclubs like Tito’s and Café Mambo. The area thrives both day and night — with calm mornings ideal for sunbathing and evenings filled with dance, food, and festive lights. These beaches perfectly capture Goa’s free-spirited essence, where relaxation meets celebration under the stars."
  },
  {
    "title": "Old Goa Churches",
    "description": "Old Goa is a UNESCO World Heritage Site that preserves the architectural grandeur of Portuguese India. The Basilica of Bom Jesus, housing the incorrupt body of St. Francis Xavier, stands as a masterpiece of Baroque art and faith. Nearby, the Sé Cathedral impresses with its towering altars and giant golden bells, symbolizing Goa’s colonial heritage. Churches like St. Cajetan and Our Lady of the Immaculate Conception reflect intricate European designs with tropical charm. Walking through Old Goa feels like stepping into history — where faith, culture, and craftsmanship blend beautifully along the serene banks of the Mandovi River."
  },
  {
    "title": "Dudhsagar Waterfalls and Mollem National Park",
    "description": "Dudhsagar Falls, meaning 'Sea of Milk', is one of India’s tallest waterfalls, cascading majestically from a height of over 1,000 feet amidst the lush Western Ghats. During monsoon, the four-tiered waterfall turns into a roaring spectacle of white foam surrounded by emerald forests. It lies within Mollem National Park, home to diverse wildlife including deer, leopards, and exotic birds. Visitors can trek through scenic trails, take jeep safaris, or enjoy train views along the iconic bridge. The blend of natural power, greenery, and serenity makes this destination a paradise for nature lovers and adventure enthusiasts alike."
  },
  {
    "title": "Fort Aguada and SinQ Beach Area",
    "description": "Fort Aguada, built in the 17th century by the Portuguese, stands proudly overlooking the Arabian Sea near SinQ Beach. Its robust architecture and lighthouse once guarded Goa’s coast from invaders and guided ships safely to the shore. Today, it’s a favorite spot for tourists to capture panoramic sea views and golden sunsets. The surrounding SinQ area is a modern hotspot with lively clubs, resorts, and cafes. Together, Fort Aguada and SinQ represent Goa’s blend of old-world heritage and contemporary luxury — where history whispers through stone walls while music and laughter fill the sea breeze nearby."
  },
  {
    "title": "Anjuna and Vagator Beaches",
    "description": "Anjuna and Vagator Beaches symbolize Goa’s bohemian spirit, famous for their rocky shores, flea markets, and music festivals. Anjuna’s Wednesday Flea Market attracts travelers with handmade jewelry, boho fashion, and local art. Vagator, with its red cliffs and palm-lined stretches, offers breathtaking views of the Arabian Sea, especially at sunset. The Chapora Fort nearby, featured in Bollywood movies, provides a perfect viewpoint for photography. These beaches are also known for hosting trance parties and beachside cafes where the sound of waves mingles with world music, capturing the true essence of Goa’s carefree lifestyle."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach, nestled in South Goa, is a crescent-shaped paradise known for its serene waters and natural beauty. Lined with coconut palms and colorful cottages, it offers a more peaceful escape compared to North Goa’s bustle. The gentle waves make it ideal for swimming, kayaking, and dolphin-spotting trips. During evenings, the beach glows with softly lit lanterns and live acoustic music from seaside cafes. Its relaxed vibe attracts both international travelers and nature seekers. Palolem perfectly embodies Goa’s quieter side — calm, soulful, and endlessly picturesque, making it a top choice for those seeking tranquility by the sea."
  },
  {
    "title": "Spice Plantations of Ponda",
    "description": "Goa’s lush hinterland in Ponda reveals a different charm through its fragrant spice plantations. Visitors can walk amidst tropical gardens filled with nutmeg, cardamom, pepper, vanilla, and betel nut trees. Guided tours explain traditional farming techniques and the medicinal uses of spices, followed by delicious Goan meals served on banana leaves. The Sahakari and Pascoal Spice Farms are particularly famous for their hospitality and authentic rural experience. These plantations offer a refreshing retreat from beach life, letting travelers connect with Goa’s agricultural heritage, sustainability practices, and the soothing rhythms of nature."
  },
  {
    "title": "Fontainhas Latin Quarter, Panjim",
    "description": "Fontainhas in Panjim is Goa’s colorful Latin Quarter, where narrow winding lanes are lined with Portuguese-style houses painted in bright blues, yellows, and reds. Each building tells a story through tiled roofs, hanging balconies, and vintage doors. The neighborhood is dotted with art galleries, bakeries, and cafes serving traditional Goan delicacies. The Chapel of St. Sebastian and local art studios add to its old-world allure. Strolling through Fontainhas feels like traveling back in time — a perfect blend of Indo-Portuguese culture, history, and charm that reflects the soul of Panjim’s heritage."
  },
  {
    "title": "Arambol Beach and Sweet Water Lake",
    "description": "Arambol, located in North Goa, offers a unique mix of spiritual energy and bohemian charm. Beyond the beach’s golden sands lies the famous Sweet Water Lake, a freshwater oasis surrounded by hills and palm trees. The area is known for yoga retreats, drum circles, and healing workshops that attract travelers seeking peace and community. Small shops sell handmade jewelry, tribal art, and holistic goods. As the sun sets, musicians and dancers gather for beachside jams, creating an enchanting atmosphere. Arambol is not just a beach — it’s an experience of freedom, art, and soulful connection."
  },
  {
    "title": "Mandovi River Cruise and Casino Zone",
    "description": "The Mandovi River in Panjim offers an unforgettable experience through scenic cruises and entertainment aboard floating casinos. Evening cruises feature live Goan music, folk dances, and dinner under starlit skies, showcasing Goa’s cultural richness. Meanwhile, the anchored casinos like Deltin Royale and Big Daddy bring a touch of Las Vegas glamour to India’s coast. With roulette tables, fine dining, and live performances, these cruises cater to both leisure and thrill. The shimmering lights reflecting on the river create a captivating skyline — a modern contrast to Goa’s beaches and temples, completing the perfect Goan holiday experience."
  }
],


      "services": [
    {
      "name": "Mumbai to Goa Car Rental",
      "description": "Meghana Cab offers reliable and affordable Mumbai to Goa car rental services for your next beach getaway. Choose from our wide range of vehicles including Sedans, Ertiga, Innova, and Innova Crysta for a comfortable journey along the scenic Mumbai-Goa highway. Whether it’s a family trip, friends’ vacation, or corporate travel, enjoy flexible rental durations, competitive pricing, and professional drivers for a relaxed and memorable journey."
    },
    {
      "name": "Mumbai to Goa Taxi Fare",
      "description": "Get the best taxi fare from Mumbai to Goa with Meghana Cab. We offer transparent, budget-friendly rates with no hidden charges. Our fares include fuel, tolls, and driver allowances. Select from various car types and enjoy a smooth, air-conditioned ride along the Konkan coast, perfect for weekend trips or long vacations."
    },
    {
      "name": "Mumbai to Goa Taxi",
      "description": "Book your Mumbai to Goa taxi with Meghana Cab and experience a comfortable and stress-free journey. Our taxis are equipped with modern amenities and driven by professional chauffeurs familiar with the Mumbai-Goa route. Choose one-way or round-trip bookings and travel at your own convenience with 24/7 service availability."
    },
    {
      "name": "Mumbai to Goa Cab Fare",
      "description": "Meghana Cab offers affordable cab fares from Mumbai to Goa tailored to your budget and travel preferences. Enjoy clean, air-conditioned vehicles with skilled drivers for a safe and enjoyable ride. We provide detailed fare breakdowns to ensure complete transparency and trust for all our passengers."
    },
    {
      "name": "Mumbai to Goa Taxi One Way Fare",
      "description": "Looking for a one-way taxi from Mumbai to Goa? Meghana Cab offers flexible one-way fares that suit solo travelers, families, or groups heading to Goa. Enjoy a convenient drop at your chosen location—whether North Goa or South Goa—with transparent pricing and professional service throughout."
    },
    {
      "name": "Mumbai to Goa Cab Price",
      "description": "Check the best Mumbai to Goa cab prices with Meghana Cab. Our prices are designed to be affordable without compromising on comfort. Choose from a fleet of well-maintained vehicles including Sedans, SUVs, and luxury cars, ensuring a smooth journey from Mumbai to Goa for all travelers."
    },
    {
      "name": "Mumbai to Goa by Car Fare",
      "description": "Traveling from Mumbai to Goa by car is made easy and affordable with Meghana Cab. We offer all-inclusive car fare packages that cover tolls, fuel, and driver allowances. Experience the freedom of road travel with our comfortable cars and courteous drivers who ensure a safe and pleasant drive to Goa."
    },
    {
      "name": "Goa to Mumbai Cab Price",
      "description": "Planning your return from Goa to Mumbai? Meghana Cab provides the best cab prices for the Goa–Mumbai route. Our fares are economical and include professional drivers, AC comfort, and on-time service. Choose one-way or round-trip options depending on your schedule."
    },
    {
      "name": "Goa to Mumbai Cab Booking",
      "description": "Book your Goa to Mumbai cab effortlessly with Meghana Cab. We offer online booking, instant confirmation, and affordable prices for travelers heading back to Mumbai. Our vehicles are well-maintained and comfortable, ensuring a safe and smooth journey from the beaches of Goa to your home or office."
    },
    {
      "name": "Goa to Mumbai Taxi",
      "description": "Meghana Cab provides convenient Goa to Mumbai taxi services for travelers returning from Goa. Enjoy a comfortable AC ride with experienced drivers who know the best routes for a quick and enjoyable trip. Our service is available round-the-clock with flexible booking options."
    },
    {
      "name": "Goa to Mumbai Cab Service",
      "description": "Enjoy a smooth and safe journey from Goa to Mumbai with Meghana Cab’s reliable cab service. Choose from Ertiga, Innova, or Sedan vehicles based on your comfort needs. We offer doorstep pickup, punctual service, and affordable fares for all our Goa to Mumbai trips."
    },
    {
      "name": "Goa to Mumbai Taxi Cost",
      "description": "Meghana Cab offers transparent and affordable taxi costs for your Goa to Mumbai journey. Our pricing is based on distance and vehicle type, with no hidden charges. Experience a relaxing long-distance drive with professional drivers and well-maintained cars."
    },
    {
      "name": "Book Cab from Mumbai to Goa",
      "description": "Booking a cab from Mumbai to Goa is quick and easy with Meghana Cab. Simply choose your preferred vehicle, confirm your booking online, and enjoy a seamless travel experience. Our service includes on-time pickups, courteous drivers, and competitive fares for a comfortable coastal road trip."
    },
    {
      "name": "Car Hire from Mumbai to Goa",
      "description": "Hire a car from Mumbai to Goa with Meghana Cab for a flexible and enjoyable trip. Choose self-drive or chauffeur-driven options as per your preference. Our cars are fully equipped for long-distance travel, offering comfort and reliability throughout your journey to Goa."
    },
    {
      "name": "Goa to Mumbai Cab Fare",
      "description": "Find the most affordable Goa to Mumbai cab fare with Meghana Cab. We offer transparent pricing for all vehicle categories—Sedan, Ertiga, and Innova Crysta. Whether for business travel or vacation return, enjoy an air-conditioned and stress-free journey at the best possible rates."
    },
    {
      "name": "Mumbai Goa Cab Service",
      "description": "Meghana Cab provides premium Mumbai-Goa cab services for travelers looking for reliability and comfort. Our drivers are trained for long-distance trips, and our cars are regularly serviced for safety. Enjoy a relaxing road journey from Mumbai to Goa with options for sightseeing en route."
    },
    {
      "name": "Mumbai to Goa Cab Booking",
      "description": "Book your Mumbai to Goa cab instantly with Meghana Cab’s online platform. Select from a wide range of cars to match your budget and travel needs. Our booking process is quick, transparent, and supported by real-time customer assistance for a hassle-free travel experience."
    },
    {
      "name": "Mumbai to Goa Cab Charges",
      "description": "Meghana Cab offers reasonable cab charges for Mumbai to Goa trips. Whether you’re traveling one-way or round-trip, we provide detailed fare structures to keep your travel budget clear. Enjoy flexible departure timings, AC comfort, and courteous drivers on every ride."
    },
    {
      "name": "Mumbai to Goa One Way Taxi",
      "description": "Book a one-way taxi from Mumbai to Goa with Meghana Cab for a convenient and budget-friendly ride. Perfect for travelers planning a long vacation or relocation, our one-way taxi service ensures comfort, safety, and punctuality from Mumbai to any destination in Goa."
    },
    {
      "name": "Mumbai to Goa One Way Cab",
      "description": "Travel from Mumbai to Goa one way with Meghana Cab’s professional service. Our clean, well-maintained vehicles and trained drivers make your long-distance trip enjoyable and stress-free. Choose affordable one-way cab rates with flexible drop points anywhere across Goa."
    }
  ],
  "tableData": [
    ["Mumbai to Goa Car Rental", "Mumbai to Goa Taxi Fare"],
    ["Mumbai to Goa Taxi", "Mumbai to Goa Cab Fare"],
    ["Mumbai to Goa Taxi One Way Fare", "Mumbai to Goa Cab Price"],
    ["Mumbai to Goa by Car Fare", "Goa to Mumbai Cab Price"],
    ["Goa to Mumbai Cab Booking", "Goa to Mumbai Taxi"],
    ["Goa to Mumbai Cab Service", "Goa to Mumbai Taxi Cost"],
    ["Book Cab from Mumbai to Goa", "Car Hire from Mumbai to Goa"],
    ["Goa to Mumbai Cab Fare", "Mumbai Goa Cab Service"],
    ["Mumbai to Goa Cab Booking", "Mumbai to Goa Cab Charges"],
    ["Mumbai to Goa One Way Taxi", "Mumbai to Goa One Way Cab"]
  ],










"whychoose": [
    {
        "WhyChooseheading": "Reliable Mumbai to Goa Cab Service",
        "WhyChoosedescription": "Meghana Cab provides dependable and comfortable cab services from Mumbai to Goa, ideal for vacations, business trips, or weekend getaways along the scenic coastal route."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop at Any Goa Destination",
        "WhyChoosedescription": "We ensure on-time pick-up from anywhere in Mumbai and prompt drop-off at your chosen location in Goa — be it Panaji, Calangute, Baga, or South Goa."
    },
    {
        "WhyChooseheading": "Experienced Long-Distance Drivers",
        "WhyChoosedescription": "Our expert drivers are familiar with the Mumbai to Goa route, focusing on safety, comfort, and efficient travel for a relaxed journey."
    },
    {
        "WhyChooseheading": "Affordable Rates with Transparent Billing",
        "WhyChoosedescription": "Enjoy competitive cab fares with no hidden costs. Meghana Cab offers clear, upfront pricing so you can travel stress-free and within budget."
    },
    {
        "WhyChooseheading": "Clean, Sanitized & Safe Vehicles",
        "WhyChoosedescription": "All our vehicles are sanitized before each trip and equipped with essential safety features like GPS, seat belts, and emergency assistance support."
    },
    {
        "WhyChooseheading": "24/7 Availability for Mumbai to Goa Travel",
        "WhyChoosedescription": "Whether you’re heading out at dawn or returning late at night, Meghana Cab is available around the clock for your Mumbai to Goa transportation needs."
    },
    {
        "WhyChooseheading": "Flexible Cab Packages",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-day packages tailored to your Goa travel itinerary. Customize your journey your way."
    },
    {
        "WhyChooseheading": "Easy Booking and Support",
        "WhyChoosedescription": "Book your Mumbai to Goa cab in minutes via our website or app. Need help? Our customer support team is available 24/7 to assist you."
    }
]



























    }







const faqData = [
    {
        question: "How can I book a Mumbai to Goa cab with Meghana Cab?",
        answer: "You can book a Mumbai to Goa cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Mumbai to Goa?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Mumbai to Goa trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one‑way cab service available from Mumbai to Goa?",
        answer: "Yes, we offer both one‑way and round‑trip cab services from Mumbai to Goa."
    },
    {
        question: "How long does it take to travel from Mumbai to Goa by cab?",
        answer: "The journey typically takes around **10 to 12 hours**, depending on traffic, route, and stops. :contentReference[oaicite:0]{index=0}"
    },
    {
        question: "What is the distance between Mumbai and Goa by road?",
        answer: "The driving distance is about **550‑600 km**, depending on which route you take. :contentReference[oaicite:1]{index=1}"
    },
    {
        question: "What is the approximate fare for a Mumbai to Goa cab?",
        answer: "Fares vary depending on car type. For example, a sedan one‑way fare may start around **₹6,500‑₹10,000**, SUVs higher. Extra charges for tolls, driver allowances, etc. :contentReference[oaicite:2]{index=2}"
    },
    {
        question: "Are tolls, parking, and driver allowances included in the fare?",
        answer: "No, tolls, parking fees, driver night/halting allowances are usually extra and clearly communicated at booking. :contentReference[oaicite:3]{index=3}"
    },
    {
        question: "Are Meghana Cab drivers experienced with long‑distance drives like Mumbai to Goa?",
        answer: "Yes, our drivers are professional, with good experience on long highway routes including coastal roads and ghat stretches."
    },
    {
        question: "Can I request breaks or custom stops during the Mumbai to Goa journey?",
        answer: "Yes, you can request stops for food, rest, sightseeing etc. Just let us know while booking."
    },
    {
        question: "Is the Mumbai to Goa service available for night departures or travel through late hours?",
        answer: "Yes, Meghana Cab offers 24/7 service, so you can plan your journey during the night or early morning if preferred."
    },
    {
        question: "What payment options are accepted for Mumbai to Goa cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab for Mumbai to Goa bookings and support?",
        answer: "You can reach Meghana Cab at +91 9075462128 for all bookings, changes or queries."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Anil Shah',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Traveling from Mumbai to Goa with Meghana Cab was a pleasant experience. The driver managed rest stops well, the cab was clean and comfortable.”',
    },
    {
        name: 'Ms. Divya Rao',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Despite the long journey, Meghana Cab made it stress‑free. Good service, punctual pickup, and friendly driver throughout Mumbai to Goa.”',
    },
];














































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cab",
  "description": "Book reliable Mumbai to Goa cab service with Meghana Cabs. Affordable taxi fares, one-way and round-trip packages, and comfortable car rentals for your scenic journey between Mumbai and Goa.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4320"
  }
};









    return (
        <div>


<Helmet>
  <title>Mumbai to Goa Cab | Affordable Taxi & Car Rental @ Meghana Cabs</title>
  <meta
    name="description"
    content="Get the best Mumbai to Goa cab service with Meghana Cabs. Affordable taxi fares, one-way and round-trip packages, and comfortable car hires for a smooth and scenic travel experience."
  />
  <meta
    name="keywords"
    content="Mumbai to Goa car rental, mumbai to goa taxi fare, mumbai to goa taxi, Mumbai to goa cab fare, Mumbai to goa taxi one way fare, mumbai to goa cab price, mumbai to goa by car fare, goa to mumbai cab price, Goa to mumbai cab booking, Mumbai to goa cab, goa to mumbai cab, goa to mumbai taxi, goa to mumbai cab service, goa to mumbai taxi cost, book cab from mumbai to goa, car hire from mumbai to goa, goa to mumbai cab fare, mumbai goa cab service, mumbai to goa cab booking, mumbai to goa cab charges, mumbai to goa cab service, mumbai to goa car hire, mumbai to goa taxi price, mumbai to goa taxi service, mumbai to goa taxi rate, mumbai to goa one way taxi, Mumbai to goa one way cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitogoacabs;